import { MESSAGE_BAR_TYPES } from '../../utils/constants';
import { SHOW_MESSAGE, HIDE_MESSAGE } from '../actions/actionTypes';

const initialState = {
    show: false,
    message: "",
    type: "",
    title: null,
    image: null,
    icon: null
}
function MessageBarReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_MESSAGE: {
            if (action.payload.message === 'account-id-error-cancel') {
                action.payload.message = `You're not linked to a merchant account. Please request an invitation from your merchant.`;
                action.payload.type = MESSAGE_BAR_TYPES.WARNING;
                return {
                    ...state,
                    show: false,
                    message: "",
                    type: ""
                }
            }
            return {
                ...state,
                show: true,
                message: action.payload.message,
                type: action.payload.type,
                title: action?.payload?.title,
                image: action?.payload?.image,
                icon: action?.payload?.icon
            }
        }
        case HIDE_MESSAGE:
            return {
                ...state,
                show: false,
                message: "",
                type: ""
            }
        default: return state;
    }
}
export default MessageBarReducer;